import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import { IcmsAliquotaStore } from "../../stores/legislacao/IcmsAliquotaStore";
import { IIcmsAliquota } from "../../model";
import * as moment from "moment";

interface IcmsAliquotasDialogEditProps {
  aliquota: IIcmsAliquota;
  onClose: () => void;
}

interface IcmsAliquotasDialogEditState {
}

@observer
export class IcmsAliquotasDialogEdit
  extends React.Component<IcmsAliquotasDialogEditProps, IcmsAliquotasDialogEditState>
{
  obs = observable({
    aliquota_edit: {} as IIcmsAliquota
  })

  async componentDidMount() {
    this.obs.aliquota_edit = createViewModel(observable(this.props.aliquota));
  }

  async handleSaveEdit(icms_aliquota) {
    if (icms_aliquota.origem_uf == "") {
      toast.error(`Origem UF obrigatório`, {});
      return
    }

    if (icms_aliquota.destino_uf == "") {
      toast.error(`Destino UF obrigatório`, {});
      return
    }

    if (icms_aliquota.origem_uf.lenth > 2) {
      toast.error(`Somente Siglas`, {});
      return
    }

    if (icms_aliquota.destino_uf.length > 2) {
      toast.error(`Somente Siglas`, {});
      return
    }

    if (icms_aliquota.aliquota_pct == "") {
      toast.error(`Alíquota obrigatório`, {});
      return
    }

    var re = new RegExp(/[0-9]/g)
    if (!re.test(icms_aliquota.aliquota_pct)) {
      toast.error(`Campo Alíquota somente número`, {});
      return
    }

    var valido_de = icms_aliquota.valido_de ? moment(icms_aliquota.valido_de).format("YYYY-MM-DD") : null;
    var valido_ate = icms_aliquota.valido_ate ? moment(icms_aliquota.valido_ate).format("YYYY-MM-DD") : null;

    if (valido_de != null && valido_ate != null) {
      if (valido_de > valido_ate) {
        toast.warning('Campo (Valido de) não pode ser maior que (Valido até)', {});
        return;
      }
    }

    let params = {
      id: icms_aliquota.id,
      origem_uf: icms_aliquota.origem_uf.toUpperCase(),
      destino_uf: icms_aliquota.destino_uf.toUpperCase(),
      aliquota_pct: parseInt(icms_aliquota.aliquota_pct),
      valido_de: valido_de,
      valido_ate: valido_ate,
    }

    await IcmsAliquotaStore.handleEdit(params)
  };

  render() {
    if (!this.obs.aliquota_edit) {
      return null;
    }

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <Dialog
        isOpen={true}
        title={"Editar ICMS Alíquota"}
        onClose={this.props.onClose}
        style={{ width: 600, height: 400 }}
      >
        <div className={Classes.DIALOG_BODY}>
          <div style={{ marginTop: -25 }}>

            <FormGroup label="Origem UF" labelFor="origem_uf">
              <InputGroup
                type="text"
                value={this.obs.aliquota_edit.origem_uf}
                onChange={(e) => this.obs.aliquota_edit.origem_uf = e.target.value}
              />
            </FormGroup>


            <FormGroup label="Destino UF" labelFor="destino_uf">
              <InputGroup
                type="text"
                value={this.obs.aliquota_edit.destino_uf}
                onChange={(e) => this.obs.aliquota_edit.destino_uf = e.target.value}
              />
            </FormGroup>


            <FormGroup label="Alíquota" labelFor="aliquota">
              <InputGroup
                type="number"
                value={this.obs.aliquota_edit.aliquota_pct}
                onChange={(e) => this.obs.aliquota_edit.aliquota_pct = e.target.value}
              />
            </FormGroup>

            <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
              <MDBCol>

                <FormGroup label="Valido de">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.aliquota_edit.valido_de ? new Date(this.obs.aliquota_edit.valido_de) : null}
                    onChange={(e) => this.obs.aliquota_edit.valido_de = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>

              </MDBCol>

              <MDBCol>

                <FormGroup label="Valido até">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.aliquota_edit.valido_ate ? new Date(this.obs.aliquota_edit.valido_ate) : null}
                    onChange={(e) => this.obs.aliquota_edit.valido_ate = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>

              </MDBCol>
            </MDBRow>
          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button
              text="Salvar"
              onClick={() => this.handleSaveEdit(this.obs.aliquota_edit)}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}